// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".video__container[data-v-47ac0b4e]{overflow:hidden;position:relative;width:100%}.video__container[data-v-47ac0b4e]:after{content:\"\";display:block;padding-top:56.25%}.video__container iframe[data-v-47ac0b4e]{height:100%;left:0;position:absolute;top:0;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
